import type { SxProps, Theme } from '@mui/material';
import { Box, Typography } from '@mui/material';

interface ReactionCountsProps {
  likeDislikeCount: number;
  likePercentage?: number;
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

function ReactionCounts({ likeDislikeCount, likePercentage, size = 'medium', sx }: ReactionCountsProps) {
  return (
    <Box className="reaction-counts" display="flex" alignItems="center" gap={1} sx={{ ...(sx as object) }}>
      <Typography fontSize={size === 'small' ? '1.3rem' : size === 'medium' ? '1.5rem' : '2rem'}>👍</Typography>
      <Typography
        variant="overline"
        color="var(--color-grey-dark)"
        lineHeight={size === 'small' ? '1rem' : size === 'medium' ? '1.2rem' : '1.5rem'}
        fontSize={size === 'small' ? '0.75rem' : size === 'medium' ? '1rem' : '1.25rem'}
      >
        ({Math.round((likePercentage ?? 0) * 100)}% of {likeDislikeCount})
      </Typography>
    </Box>
  );
}

export default ReactionCounts;
